
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { OptimizedImage } from "@/components/ui/image";

interface ToolkitCardProps {
  title: string;
  description: string;
  icon?: LucideIcon; // Made optional since we'll be using the logo instead
  linkTo: string;
  buttonText: string;
  imageSrc?: string;
  onClick?: (e: React.MouseEvent) => void;
}

const ToolkitCard: React.FC<ToolkitCardProps> = ({
  title,
  description,
  icon: Icon,
  linkTo,
  buttonText,
  imageSrc,
  onClick,
}) => {
  const ButtonContent = (
    <Button className="w-full bg-[#34BF49] hover:bg-[#2da940] text-white" onClick={onClick}>
      {buttonText}
    </Button>
  );

  return (
    <Card className="flex flex-col h-full transition-all hover:shadow-lg w-full text-center relative overflow-hidden bg-gradient-to-br from-white to-gray-50 border border-gray-100">
      <div className="absolute top-0 left-0 w-full h-1 bg-[#34BF49]"></div>
      <CardHeader className="flex flex-col items-center pt-8">
        <div className="w-20 h-20 rounded-full bg-white p-4 shadow-md mb-5 flex items-center justify-center border border-gray-100">
          <OptimizedImage
            src="/lovable-uploads/a532a314-ae66-4d0d-befd-75bdc6a1acb5.png" 
            alt="Andy Logo" 
            className="w-full h-full object-contain"
            width={46}
            height={46}
          />
        </div>
        <CardTitle className="text-xl font-bold mt-2">{title}</CardTitle>
        <CardDescription className="text-center max-w-md mx-auto mt-2">{description}</CardDescription>
      </CardHeader>
      <CardContent className="flex-grow">
        {/* Content image removed as requested */}
      </CardContent>
      <CardFooter className="justify-center pb-8">
        {onClick ? ButtonContent : (
          <Button asChild className="w-full bg-[#34BF49] hover:bg-[#2da940] text-white">
            <Link to={linkTo}>{buttonText}</Link>
          </Button>
        )}
      </CardFooter>
    </Card>
  );
};

export default ToolkitCard;
